import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import moment from 'moment';

import { WarehouseReportEnum } from 'Common/FieldEnum';
import { WAREHOUSE_KITCHEN_LOAD_FORM_NAME } from 'Common/FormEnum';
import { submitForm, resetForm } from 'State/forms/actions';
import { errorToast } from 'Common/ToastHelper';
import { getStorageLocationForCurrentSite } from 'State/filters/actions';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { makeOptionsDataRemoveEmpty } from 'Common/FormHelper';
import { GenericEnum } from 'Common/Constants/Enumeration/CommonEnum';
import {
  TabEnum,
  PickListTabs,
  PrintSortOptions,
} from 'Common/Constants/Enumeration/WarehouseReports';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { resetDirty } from 'State/dirtyTracking/actions';

import { WarehouseLoad } from './../containers/WarehouseLoad';
import * as actions from './../state/actions';
import 'PageStyles/reports/inventory/warehouse.less';

class WarehousePickListContainer extends Component {
  static propTypes = {
    fetchWHKITListLoading: PropTypes.bool.isRequired,
    wHKITListData: PropTypes.array.isRequired,
    fetchWHKITListLoadingError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    printWHKITLoadReportsLoading: PropTypes.bool.isRequired,
    fetchTruckRouteListLoading: PropTypes.bool.isRequired,
    truckRouteListData: PropTypes.array.isRequired,
    fetchTruckRouteListLoadingError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),

    printLoadingError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    storageLocationData: PropTypes.array.isRequired,
    storageLocationDataLoading: PropTypes.bool.isRequired,
    storageLocationDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    submitForm: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    getStorageLocationForCurrentSite: PropTypes.func.isRequired,
    resetDirty: PropTypes.func.isRequired,
  };

  static defaultProps = {
    fetchWHKITListLoadingError: null,
    fetchTruckRouteListLoadingError: null,
    printLoadingError: null,
    storageLocationDataError: null,
  };

  async componentDidMount() {
    const {
      getWarehouseKitchenList,
      getTruckRouteList,
      getStorageLocationForCurrentSite,
      resetDirty,
    } = this.props;
    getTruckRouteList();
    getStorageLocationForCurrentSite();
    await getWarehouseKitchenList();
    const warehouseOptions = makeOptionsDataRemoveEmpty(
      this.props.wHKITListData
    );
    this.props.changeDropDownData(
      WarehouseReportEnum.WarehouseKitchen,
      warehouseOptions[0].value
    );
    resetDirty();
  }

  componentDidUpdate(prevProps, prevState) {
    const { clearPrintLoadingError } = this.props;
    if (
      errorToast(this.props, prevProps, 'fetchWHKITListLoadingError') ||
      errorToast(this.props, prevProps, 'printLoadingError') ||
      errorToast(this.props, prevProps, 'fetchTruckRouteListLoadingError') ||
      errorToast(this.props, prevProps, 'storageLocationDataError')
    ) {
      clearPrintLoadingError();
    }
  }

  componentWillUnmount() {
    toast.dismiss();
  }

  onHandleLoadPrintSubmit = values => {
    const truckObj = _.find(this.props.truckRouteListData, data => {
      return data.Id === values[WarehouseReportEnum.TruckRoute];
    });
    const requestJson = {
      ...values,
      [WarehouseReportEnum.Type]: TabEnum.Load,
      [WarehouseReportEnum.TruckRouteDescription]: truckObj
        ? truckObj.Description
        : '',
      [WarehouseReportEnum.TruckRoute]: truckObj ? truckObj.Type : '',
    };
    this.props.getPrintLoad(requestJson);
  };
  onLoadPrintClick = () => {
    this.props.submitForm(WAREHOUSE_KITCHEN_LOAD_FORM_NAME);
  };

  getMainProps = () => {
    const { printWHKITLoadReportsLoading } = this.props;
    return {
      toolbox: {
        rightButtons: [
          {
            content: 'Print',
            onClick: this.onLoadPrintClick,
            loading: printWHKITLoadReportsLoading,
          },
        ],
        shown: true,
      },
    };
  };
  render() {
    const {
      wHKITListData,
      storageLocationData,
      truckRouteListData,
      printWHKITLoadReportsLoading,
      fetchWHKITListLoading,
      fetchTruckRouteListLoading,
      storageLocationDataLoading,
    } = this.props;
    return (
      <WarehouseLoad
        initialValues={{
          [WarehouseReportEnum.WarehouseKitchen]: GenericEnum.ZeroString,
          [WarehouseReportEnum.IncludeItemsForOpenOrder]: true,
          [WarehouseReportEnum.GroupBy]: PickListTabs.TruckRoute,
          [WarehouseReportEnum.SortBy]: PrintSortOptions.ItemCode,
          [WarehouseReportEnum.DateFrom]: moment().format(DATE_FORMAT_FOR_UI),
          [WarehouseReportEnum.DateTo]: moment().format(DATE_FORMAT_FOR_UI),
          [WarehouseReportEnum.StorageLocation]: GenericEnum.InitialFilterValue,
          [WarehouseReportEnum.TruckRoute]: GenericEnum.InitialFilterValue,
          [WarehouseReportEnum.OrderingSite]: GenericEnum.ZeroString,
        }}
        printLoading={printWHKITLoadReportsLoading}
        data={wHKITListData}
        storageLocationData={storageLocationData}
        truckRouteData={truckRouteListData}
        onSubmit={this.onHandleLoadPrintSubmit}
        onPrintClick={this.onLoadPrintClick}
        getMainProps={this.getMainProps}
        fetchWHKITListLoading={fetchWHKITListLoading}
        fetchTruckRouteListLoading={fetchTruckRouteListLoading}
        storageLocationDataLoading={storageLocationDataLoading}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { warehousePickListReport } = state.ReportsState;
  const {
    CommonState: { filters },
  } = state;
  const {
    fetchWHKITListLoading,
    wHKITListData,
    fetchWHKITListLoadingError,
    printWHKITLoadReportsLoading,
    fetchTruckRouteListLoading,
    truckRouteListData,
    fetchTruckRouteListLoadingError,
    printLoadingError,
  } = warehousePickListReport;
  ownProps.setPageLevelDirty(
    getIsDirty(WAREHOUSE_KITCHEN_LOAD_FORM_NAME)(state)
  );

  return {
    fetchWHKITListLoading,
    wHKITListData,
    fetchWHKITListLoadingError,
    printWHKITLoadReportsLoading,
    fetchTruckRouteListLoading,
    truckRouteListData,
    fetchTruckRouteListLoadingError,
    printLoadingError,
    storageLocationData: filters.storageLocationData,
    storageLocationDataLoading: filters.storageLocationDataLoading,
    storageLocationDataError: filters.storageLocationDataError,
  };
};

export const WarehousePickList = connect(
  mapStateToProps,
  {
    ...actions,
    submitForm,
    resetForm,
    getStorageLocationForCurrentSite,
    resetDirty,
  }
)(WarehousePickListContainer);



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/warehousepicklist/containers/WarehousePickList.js